import React from 'react';
import { ChooseModelContainer } from '../../../Shared/index';
import { LessonForm as SharedLessonForm } from '../../../Shared/components/lessons/lessonForm';

// Wrapper component to adapt ChooseModelContainer API to match Diagnostic's ChooseModel API
const ChooseModelWrapper = ({ conceptsFeedback, modelConceptUID, updateModelConcept }) => (
  <ChooseModelContainer
    conceptsFeedback={conceptsFeedback}
    modelConceptUID={modelConceptUID}
    onRemove={() => updateModelConcept(null)}
    onSave={(uid) => updateModelConcept(uid)}
  />
);

const LessonForm = (props) => (
  <SharedLessonForm
    {...props}
    ChooseModelComponent={ChooseModelWrapper}
    showELL={false}
  />
);

export default LessonForm;
